<main [ngClass]="{'gray-back': !sharedState.isStockLocked}" class="container">
  <router-outlet></router-outlet>
</main>
